import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=03f6d298"
import script from "./PersonalSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports